import { addNavMenuSection, registerBulkAction } from '@vendure/admin-ui/core';
import { deleteReferralBulkAction } from './components/referral-list/bulk-actions';

export default [
    registerBulkAction(deleteReferralBulkAction),
    addNavMenuSection({
        id: 'referral',
        label: 'Referrals',
        items: [
            {
                id: 'referrals',
                label: 'Referrals',
                routerLink: ['/extensions/referral/referrals'],
                icon: 'tags',
            },
        ],
    }),
];
